/**
 * SaaS Branding — point unique côté frontend.
 *
 * Aucun composant ne doit contenir le nom de marque en dur pour du texte utilisateur.
 * Tout passe par ce module, qui lit depuis `frontend/.env` (compile-time)
 * avec des valeurs par défaut compatibles avec l'existant.
 *
 * Variables `.env` prises en charge (toutes optionnelles) :
 *   REACT_APP_NAME              → Nom court affiché (défaut: "Averdy Agency")
 *   REACT_APP_LEGAL_NAME        → Raison sociale (défaut: APP_NAME)
 *   REACT_APP_DOMAIN            → Domaine racine (défaut: "clarix.fr")
 *   REACT_APP_TAGLINE           → Slogan court (défaut: "Le CFO augmenté")
 *   REACT_APP_SUPPORT_EMAIL     → Email support
 *
 * ⚠️ Pour changer de marque : éditer /app/frontend/.env + /app/backend/.env
 * et rebuild frontend. Aucune modification de code requise.
 */

export const APP_NAME = process.env.REACT_APP_NAME || "Averdy Agency";
export const APP_LEGAL_NAME = process.env.REACT_APP_LEGAL_NAME || APP_NAME;
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || "clarix.fr";
export const APP_TAGLINE = process.env.REACT_APP_TAGLINE || "Le CFO augmenté";
export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || `support@${APP_DOMAIN}`;
export const PUBLIC_APP_URL =
  process.env.REACT_APP_PUBLIC_URL || `https://${APP_DOMAIN}`;

/** Nom de marque suivi d'un suffixe produit ("Averdy Agency IA" / "Averdy Agency RH" / "Averdy Agency Legal"). */
export const productLabel = (module) =>
  module ? `${APP_NAME} ${module}` : APP_NAME;

/** Convertit tout template contenant le placeholder {app} en APP_NAME. */
export const brand = (template) =>
  typeof template === "string" ? template.replace(/\{app\}/g, APP_NAME) : template;

/** Met à jour dynamiquement le <title> du document + <meta description>. */
export const applyDocumentBranding = () => {
  if (typeof document === "undefined") return;
  document.title = APP_NAME;
  const meta = document.querySelector('meta[name="description"]');
  if (meta) meta.setAttribute("content", `${APP_NAME} — ${APP_TAGLINE}`);
};

export default {
  APP_NAME,
  APP_LEGAL_NAME,
  APP_DOMAIN,
  APP_TAGLINE,
  SUPPORT_EMAIL,
  PUBLIC_APP_URL,
  productLabel,
  brand,
  applyDocumentBranding,
};
